import { useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';

import {
  FacilitatorChatContext,
  FacilitatorChatContextProps
} from '../../contexts/facilitator-chat';
import MenuItem from '../../components/menu-item';
import { GameContext } from '../../contexts/game';
import { Logo, LogoText } from '../../components/logo';
import { LayoutContext } from '../../contexts/layout-provider';
import { useGetManualScoringAnswers } from '../../hooks/use-get-manual-scoring';

const FacilitatorMenu = () => {
  const { gameCode } = useParams();

  const auth = useAuth();
  const facilitatorId = auth.user?.profile.sub;
  const layout = useContext(LayoutContext);
  const [game] = useContext(GameContext);
  const { newChat } = useContext(
    FacilitatorChatContext
  ) as FacilitatorChatContextProps;

  const { data: taskScorings } = useGetManualScoringAnswers(gameCode);

  return (
    <aside
      className={`app-side-nav ${layout.navIsCollapsed ? 'app-side-nav--collapsed' : ''}`}>
      <div className={'nav-header'}>
        <div className={`hamburger`}>
          <span
            className="material-symbols-outlined cursor-pointer text-decoration-none"
            onClick={layout.toggleNavIsCollapsed}>
            menu
          </span>
        </div>
        <div className={`d-flex w-100 h-100 align-items-center pe-3`}>
          {layout.navIsCollapsed ? (
            <Logo
              className="p-2"
              primaryColor={'#4698cb'}
              width={'3rem'}
              height={'3rem'}
            />
          ) : (
            <LogoText primaryColor={'#4698cb'} />
          )}
        </div>
      </div>
      <hr />

      <div className={'aside-menu'}>
        <MenuItem to={``} icon={'home'} label={'Dashboard'} />
        {game.activityState && game.activityState.hasGame && (
          <>
            <MenuItem to={`map`} icon={'map'} label={'Map'} />
            <MenuItem
              to={`task-scoring`}
              icon={'tour'}
              label={'Task Scoring'}
              notificationCount={taskScorings.length}
            />
            <MenuItem
              to={`all-tasks`}
              icon={'check_circle'}
              label={'All Tasks'}
            />
            <MenuItem
              to={`all-on-demand-tasks`}
              icon={'check_circle'}
              label={'All On-Demand Tasks'}
            />
            <MenuItem to={'inventory-bank'} icon={'trip'} label={'Inventory'} />
          </>
        )}

        <hr />

        <MenuItem
          to={`chat`}
          icon={'chat_bubble'}
          label={'Chat'}
          notificationCount={
            newChat.filter((chat) => chat.author.id !== facilitatorId).length
          }
        />
        {game.activityState && game.activityState.hasGame && (
          <MenuItem
            to={`push-content`}
            icon={'content_paste_go'}
            label={'Push Content'}
          />
        )}

        <hr />

        <MenuItem to={`players`} icon={'person'} label={'Players'} />
        <MenuItem to={`teams`} icon={'group'} label={'Teams'} />
        <MenuItem to={`groups`} icon={'group_work'} label={'Groups'} />

        <hr />

        <MenuItem to={`settings`} icon={'settings'} label={'Settings'} />
        <MenuItem
          to={`/games/${game.gameCode}/leaderboard`}
          icon={'leaderboard'}
          label={'Leaderboard'}
          enableOpenNewWindow
        />
        {game.activityState && game.activityState.hasFeedback && (
          <MenuItem to={`feedback`} icon={'add_reaction'} label={'Feedback'} />
        )}
      </div>
    </aside>
  );
};

export default FacilitatorMenu;
